import {CA} from './analytics/Analytics'
import {ViewPopup} from './ui_popup/ViewPopup'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {PIXI} from '@colonist/pixi'
import {LobbyImage} from '@colonist/types'
import {SocketLobbySend} from './socket/SocketLobbySend'
import {logDebugInfo} from './ui_utils/Utils'
import {notificationController} from './EntryShared'
import {ViewPopupHardwareAcceleration} from './ui_popup/ViewPopupHardwareAcceleration'

export class UIDocument {
    static debugOptions() {
        if(UIUtilsEjsVariables.isProduction) return
        logDebugInfo('debugOptions', [`Is mobile ${PIXI.utils.isMobile.any}`])
        logDebugInfo('debugOptions', [`Is phone ${PIXI.utils.isMobile.phone}`])
        logDebugInfo('debugOptions', [`Webgl supported ${PIXI.utils.isWebGLSupported()}`])
        logDebugInfo('debugOptions', [`Document referrer ${document.referrer}. Location ${document.location.href}`])
    }

    static showTestServerPopup() {
        if(UIUtilsEjsVariables.isProduction) return
        notificationController.showNotification(LobbyImage.Admin, {key: 'strings:homePage.header.testServerMessage'})
    }

    static webGLCheck() {
        if(PIXI.utils.isWebGLSupported()) {
            CA.sendGoogleAnalyticsEvent(CA.Category.General, CA.Label.GeneralWebGLEnabled)
        } else {
            CA.sendGoogleAnalyticsEvent(CA.Category.General, CA.Label.GeneralWebGLDisabled)
            if(UIUtilsEjsVariables.isUserOnDiscord) this.showHardwareAccelerationPopup()
            else if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) this.showWebGLPopupOnMobileApp()
            else this.showWebGLPopup()
        }
    }

    static interactedWithSiteEventListener?: () => void

    static monitorIfUserInteractedWithSite(hasUserAlreadyInteractedWithSiteInPreviousSession: boolean | undefined) {
        if(hasUserAlreadyInteractedWithSiteInPreviousSession) return
        if(this.interactedWithSiteEventListener != undefined) return
        this.interactedWithSiteEventListener = () => this.sendUserInteractedWithSite()
        document.addEventListener('mousemove', this.interactedWithSiteEventListener)
        document.addEventListener('mousedown', this.interactedWithSiteEventListener)
    }

    static sendUserInteractedWithSite() {
        if(this.interactedWithSiteEventListener == undefined) return
        document.removeEventListener('mousemove', this.interactedWithSiteEventListener)
        document.removeEventListener('mousedown', this.interactedWithSiteEventListener)
        SocketLobbySend.interactedWithSite()
    }

    static showWebGLPopup() {
        const popup = new ViewPopup({key: 'strings:homePage.popups.webGLInactive.title'}, {key: 'strings:homePage.popups.webGLInactive.body'}, () => {
            window.location.replace('https://blog.colonist.io/how-to-enable-webgl/')
        }, () => undefined, false, {
            showXButton: false,
        })
        popup.changeCheckButtonText({key: 'strings:homePage.popups.webGLInactive.showMeHow'})
        popup.show()
    }

    static showHardwareAccelerationPopup() {
        new ViewPopupHardwareAcceleration()
    }

    static showWebGLPopupOnMobileApp() {
        const popup = new ViewPopup({key: 'strings:homePage.popups.webGLInactiveOnMobileApp.title'}, {key: 'strings:homePage.popups.webGLInactiveOnMobileApp.body'}, () => undefined, () => undefined, false, {
            showXButton: false,
            showCheckButton: false,
        })

        popup.addBodyContent({key: 'strings:homePage.popups.webGLInactiveOnMobileApp.nov12IOS187issue'})
        popup.show()
    }
}
